/* jy-home.js — flash countdown supports days (v2) */
/* ============================================================
   JUSTYOL — home sections JS
   - mobile hero slider (snap scroll, dots, auto-rotate 4.5s, pause 8s on touch)
   - flash countdown
   - recently viewed (localStorage "jy_recent")
   ============================================================ */
(function () {
  'use strict';

  /* loaded by several home sections — run once */
  if (window.__jyHomeJS) return;
  window.__jyHomeJS = true;

  var RTL = document.documentElement.getAttribute('dir') === 'rtl';

  /* ---------- hero slider (mobile) ----------
     Square cards with the next one peeking. The active progress bar is a CSS
     animation (5s); its animationend advances the rail, so pausing is just
     animation-play-state. Touch/drag holds it for 8s. */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- hero analytics ----------
     Which slide is seen and clicked, per device (d = desktop, m = mobile):
     - GA4 view_promotion / select_promotion (Monetisation > Promotions)
     - Clarity custom event jy_hero_<view|click>_<d|m><slot>
     - first-party counter on the COD worker (/t, step hero_<view|click>.<d|m><slot>,
       once per session per step; read with POST /funnel)
     A view counts once per page load, only while the hero is on screen. */
  var HERO_EP = 'https://justyol-cod.justyol.workers.dev';
  try {
    if (window.JY_COD_ENDPOINT) HERO_EP = new URL(window.JY_COD_ENDPOINT).origin;
  } catch (e) {
    /* keep default */
  }
  var heroSeen = {};
  function heroTrack(kind, dev, slot, el) {
    if (!el) return;
    var key = kind + dev + slot;
    if (kind === 'view') {
      if (heroSeen[key]) return;
      heroSeen[key] = 1;
    }
    var plat = window.JY_IS_APP === true ? 'app' : 'web';
    var payload = {
      promotion_id: el.getAttribute('data-jy-promo-id') || '',
      promotion_name: el.getAttribute('data-jy-promo-name') || '',
      creative_slot: dev + slot,
      creative_name: dev === 'd' ? 'hero_desktop' : 'hero_mobile',
      jy_platform: plat,
    };
    var gaName = kind === 'view' ? 'view_promotion' : 'select_promotion';
    try {
      if (window.gtag) window.gtag('event', gaName, payload);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: gaName }, payload));
    } catch (e) {}
    try {
      if (window.clarity) window.clarity('event', 'jy_hero_' + kind + '_' + dev + slot);
    } catch (e) {}
    var step = 'hero_' + kind + '.' + dev + slot;
    try {
      if (sessionStorage.getItem('jyf_' + step)) return;
      sessionStorage.setItem('jyf_' + step, '1');
    } catch (e) {
      /* private mode: count it anyway */
    }
    var body = JSON.stringify({ e: step, p: plat, l: (document.documentElement.lang || 'fr').slice(0, 2) });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(HERO_EP + '/t', body)) return;
    } catch (e) {}
    try {
      fetch(HERO_EP + '/t', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  function initSlider(root) {
    if (root.dataset.jyInit) return;
    root.dataset.jyInit = '1';
    var rail = root.querySelector('[data-jy-hslider-rail]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-jy-hslider-dot]'));
    if (!rail || rail.children.length < 2) return;
    var slides = Array.prototype.slice.call(rail.children);
    var count = slides.length;
    var holdTimer = null;
    var shown = 0;

    function delta(el) {
      var r = el.getBoundingClientRect();
      var rr = rail.getBoundingClientRect();
      var pad = parseFloat(getComputedStyle(rail).paddingInlineStart) || 0;
      return RTL ? r.right - (rr.right - pad) : r.left - (rr.left + pad);
    }
    function current() {
      var best = 0;
      var min = Infinity;
      slides.forEach(function (sl, i) {
        var d = Math.abs(delta(sl));
        if (d < min) {
          min = d;
          best = i;
        }
      });
      return best;
    }
    var snapT = null;
    function goTo(n) {
      var to = (n + count) % count;
      /* snapping fights programmatic scrolls (it re-snaps to the card it
         last held, and snap-stop halts at every card passed), so it is
         switched off while we move and back on once we've landed */
      rail.style.scrollSnapType = 'none';
      rail.scrollBy({ left: delta(slides[to]), behavior: REDUCED ? 'auto' : 'smooth' });
      clearTimeout(snapT);
      snapT = setTimeout(function () {
        rail.style.scrollSnapType = '';
      }, 900);
    }
    var mVisible = false;
    function mView() {
      if (mVisible) heroTrack('view', 'm', shown + 1, slides[shown]);
    }
    slides.forEach(function (sl, k) {
      sl.addEventListener('click', function () {
        heroTrack('click', 'm', k + 1, sl);
      });
    });
    function paint() {
      var idx = current();
      if (idx === shown && dots[idx] && dots[idx].classList.contains('on')) return;
      shown = idx;
      mView();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-done', i < idx);
        /* re-arm the fill animation on the new active bar */
        d.classList.remove('on');
        if (i === idx) {
          void d.offsetWidth;
          d.classList.add('on');
        }
      });
    }
    function hold() {
      root.classList.add('is-paused');
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        root.classList.remove('is-paused');
      }, 8000);
    }

    var scrollT = null;
    rail.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(paint, 80);
      },
      { passive: true }
    );
    rail.addEventListener('touchstart', hold, { passive: true });
    rail.addEventListener('pointerdown', hold, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) {
        e.preventDefault();
        hold();
        goTo(i);
      });
      d.addEventListener('animationend', function () {
        if (d.classList.contains('on')) goTo(shown + 1);
      });
    });

    document.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target);
      if (k < 0) return;
      root.classList.add('is-paused');
      goTo(k);
    });
    if (REDUCED) root.classList.add('is-static');
    /* only run while the slider is on screen and the tab is visible */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (es) {
          root.classList.toggle('is-off', !es[0].isIntersecting);
          mVisible = es[0].isIntersecting && es[0].intersectionRatio >= 0.5;
          mView();
        },
        { threshold: [0, 0.5] }
      ).observe(root);
    }
    paint();
  }

  /* ---------- hero carousel (desktop, B3 "ambiance") ----------
     Centred slide with its neighbours peeking. A copy of the last slide sits
     before the first and a copy of the first after the last, so it loops
     without rewinding; after landing on a copy we jump to the real slide
     with transitions off. The band's blurred background follows the active
     slide. Timing lives in the active bar's CSS animation; hover, keyboard
     focus, the pause button, a hidden tab, being off screen and the theme
     editor all pause it. */
  function initCarousel(root) {
    if (root.dataset.jyInit) return;
    root.dataset.jyInit = '1';
    var track = root.querySelector('[data-jy-hcar-track]');
    var stage = track && track.parentElement;
    var real = Array.prototype.slice.call(root.querySelectorAll('[data-jy-hcar-slide]'));
    var bgs = Array.prototype.slice.call(root.querySelectorAll('[data-jy-hcar-bg]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-jy-hcar-go]'));
    var countEl = root.querySelector('[data-jy-hcar-count]');
    var pauseBtn = root.querySelector('[data-jy-hcar-pause]');
    var n = real.length;
    if (!track || n < 2) return;

    function cloneOf(el) {
      var c = el.cloneNode(true);
      c.removeAttribute('data-jy-hcar-slide');
      c.removeAttribute('data-shopify-editor-block');
      c.setAttribute('aria-hidden', 'true');
      c.tabIndex = -1;
      c.classList.remove('is-on');
      return c;
    }
    track.insertBefore(cloneOf(real[n - 1]), real[0]);
    track.appendChild(cloneOf(real[0]));
    /* the copy in front pushes the first slide one step along; place() puts
       it back with a transform in the same frame (transforms are not layout
       shifts, a margin change is) */
    var all = Array.prototype.slice.call(track.children); /* [clone(last), ...real, clone(first)] */

    var i = 0; /* real index */
    var pos = 1; /* index in `all` */
    var held = false;
    var reasons = {};
    var pad2 = function (x) {
      return x < 10 ? '0' + x : String(x);
    };

    function place(jump) {
      var w = all[0].offsetWidth;
      var g = parseFloat(getComputedStyle(track).columnGap) || 0;
      var shift = pos * (w + g); /* the CSS margin centres all[0]; pos counts from there */
      track.classList.toggle('is-jump', !!jump);
      track.style.transform = 'translateX(' + (RTL ? shift : -shift) + 'px)';
      if (jump) {
        void track.offsetWidth;
        track.classList.remove('is-jump');
      }
    }
    function mark() {
      all.forEach(function (el, k) {
        el.classList.toggle('is-on', k === pos);
      });
      real.forEach(function (sl, j) {
        sl.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        sl.tabIndex = j === i ? 0 : -1;
      });
      bgs.forEach(function (b, j) {
        b.classList.toggle('is-on', j === i);
      });
      /* start loading the neighbours' artwork ahead of time */
      [all[pos - 1], all[pos + 1]].forEach(function (el) {
        if (!el) return;
        el.querySelectorAll('img[loading="lazy"]').forEach(function (x) {
          x.loading = 'eager';
        });
      });
      [bgs[(i + 1) % n], bgs[(i + n - 1) % n]].forEach(function (b) {
        var im = b && b.querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      });
      bars.forEach(function (b, j) {
        b.classList.toggle('is-done', j < i);
        b.classList.remove('is-on');
        b.removeAttribute('aria-current');
        if (j === i) {
          void b.offsetWidth;
          b.classList.add('is-on');
          b.setAttribute('aria-current', 'true');
        }
      });
      if (countEl) countEl.textContent = pad2(i + 1) + ' / ' + pad2(n);
      dView();
    }
    var dVisible = false;
    function dView() {
      if (dVisible && !document.hidden) heroTrack('view', 'd', i + 1, real[i]);
    }
    function go(k, viaClone) {
      /* without transitions there is no transitionend to hop off a copy */
      if (REDUCED) viaClone = 0;
      if (viaClone === 1) {
        pos = n + 1; /* the copy of the first, after the last */
        i = 0;
      } else if (viaClone === -1) {
        pos = 0; /* the copy of the last, before the first */
        i = n - 1;
      } else {
        i = (k + n) % n;
        pos = i + 1;
      }
      mark();
      place(REDUCED);
    }
    function next() {
      if (i === n - 1) go(0, 1);
      else go(i + 1);
    }
    function prev() {
      if (i === 0) go(n - 1, -1);
      else go(i - 1);
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      if (pos === 0 || pos === n + 1) {
        pos = i + 1;
        all.forEach(function (el, k) {
          el.classList.toggle('is-on', k === pos);
        });
        place(true);
      }
    });
    function sync() {
      var paused =
        held ||
        Object.keys(reasons).some(function (k) {
          return reasons[k];
        });
      root.classList.toggle('is-paused', paused);
      root.classList.toggle('is-held', held);
      if (pauseBtn) pauseBtn.setAttribute('aria-pressed', held ? 'true' : 'false');
    }

    bars.forEach(function (b, j) {
      b.addEventListener('click', function () {
        go(j);
      });
      b.addEventListener('animationend', function () {
        if (b.classList.contains('is-on')) next();
      });
    });
    /* a peeking neighbour brings itself to the centre instead of navigating */
    all.forEach(function (el, k) {
      el.addEventListener('click', function (e) {
        if (k === pos) {
          /* the active slide (or its looping copy) is a real click-through */
          var r = k === 0 ? n - 1 : k === n + 1 ? 0 : k - 1;
          heroTrack('click', 'd', r + 1, real[r]);
          return;
        }
        e.preventDefault();
        if (k === 0) prev();
        else if (k === n + 1) next();
        else go(k - 1);
      });
    });
    var pBtn = root.querySelector('[data-jy-hcar-prev]');
    var nBtn = root.querySelector('[data-jy-hcar-next]');
    if (pBtn) pBtn.addEventListener('click', prev);
    if (nBtn) nBtn.addEventListener('click', next);
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        held = !held;
        sync();
      });
    }
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      ((e.key === 'ArrowRight') !== RTL ? next : prev)();
    });
    root.addEventListener('mouseenter', function () { reasons.hover = true; sync(); });
    root.addEventListener('mouseleave', function () { reasons.hover = false; sync(); });
    root.addEventListener('focusin', function () { reasons.focus = true; sync(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) {
        reasons.focus = false;
        sync();
      }
    });
    document.addEventListener('visibilitychange', function () {
      reasons.tab = document.hidden;
      sync();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (es) {
          reasons.view = !es[0].isIntersecting;
          dVisible = es[0].isIntersecting && es[0].intersectionRatio >= 0.5;
          dView();
          sync();
        },
        { threshold: [0, 0.5] }
      ).observe(root);
    }
    var x0 = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      x0 = e.clientX;
    });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      ((dx < 0) !== RTL ? next : prev)();
    });
    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        place(true);
      }, 120);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var k = real.indexOf(e.target);
      if (k < 0) return;
      reasons.editor = true;
      go(k);
      sync();
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (real.indexOf(e.target) < 0) return;
      reasons.editor = false;
      sync();
    });
    if (REDUCED) root.classList.add('is-static');
    mark();
    place(true);
    sync();
  }

  /* ---------- countdown ---------- */
  /* ONE shared ticker drives every countdown on the page (hero + sticky + each
     card) instead of one setInterval per element — a 40-product flash grid used
     to spin ~42 identical timers. Detached/finished countdowns are dropped each
     tick, which also fixes the interval leak on shopify:section:load. */
  var CD_LIST = [];
  var CD_TIMER = null;
  var CD_DAY = 86400000;
  var CD_MA_OFFSET = 3600000; /* Morocco UTC+1 */
  function cdPad(n) {
    return String(n).padStart(2, '0');
  }
  function cdTarget(cd) {
    if (cd.rollMs) {
      /* rolling per-visitor timer (localStorage), shared by all countdowns of
         the same duration so hero/sticky/cards stay in lock-step */
      var key = 'jy_flash_end_' + cd.rollMs;
      var stored = 0;
      try {
        stored = parseInt(localStorage.getItem(key) || '0', 10);
      } catch (e) {}
      if (!stored || stored <= Date.now()) {
        stored = Date.now() + cd.rollMs;
        try {
          localStorage.setItem(key, String(stored));
        } catch (e) {}
      }
      return stored;
    }
    if (cd.hasRealEnd) return cd.end;
    /* evergreen fallback: next midnight MOROCCO time */
    var sinceMaMidnight = (Date.now() + CD_MA_OFFSET) % CD_DAY;
    return Date.now() + (CD_DAY - sinceMaMidnight);
  }
  function cdRender(cd) {
    var diff = cd.t - Date.now();
    if (diff <= 0) {
      if (cd.hasRealEnd) {
        /* a real deadline that passed hides the whole timer — no fake reset */
        var wrap = cd.el.closest('[data-jy-flash-sticky]') || cd.segs.h.closest('[data-jy-cd-wrap]') || cd.segs.h.parentElement;
        if (wrap) wrap.hidden = true;
        cd.done = true;
        return;
      }
      cd.t = cdTarget(cd);
      diff = Math.max(0, cd.t - Date.now());
    }
    var totalH = Math.floor(diff / 3.6e6);
    var m = Math.floor((diff % 3.6e6) / 6e4);
    var s = Math.floor((diff % 6e4) / 1000);
    if (cd.segs.d) {
      var d = Math.floor(diff / CD_DAY);
      cd.segs.d.textContent = cdPad(d);
      var dseg = cd.segs.d.closest('[data-jy-cd-dseg]');
      if (dseg) dseg.hidden = d <= 0;
      cd.segs.h.textContent = cdPad(totalH % 24);
    } else {
      cd.segs.h.textContent = cdPad(totalH);
    }
    cd.segs.m.textContent = cdPad(m);
    cd.segs.s.textContent = cdPad(s);
  }
  function cdTickAll() {
    for (var i = CD_LIST.length - 1; i >= 0; i--) {
      var cd = CD_LIST[i];
      if (cd.done || !cd.el.isConnected) {
        CD_LIST.splice(i, 1);
        continue;
      }
      cdRender(cd);
    }
    if (!CD_LIST.length && CD_TIMER) {
      clearInterval(CD_TIMER);
      CD_TIMER = null;
    }
  }
  function initCountdown(el) {
    if (el.dataset.jyInit) return;
    el.dataset.jyInit = '1';
    var segs = {
      d: el.querySelector('[data-jy-cd-d]'),
      h: el.querySelector('[data-jy-cd-h]'),
      m: el.querySelector('[data-jy-cd-m]'),
      s: el.querySelector('[data-jy-cd-s]'),
    };
    if (!segs.h) return;
    /* editor value = Morocco wall-clock; no-timezone strings get +01:00.
       "24h"/"Nh" = rolling per-visitor duration (localStorage). */
    var raw = (el.dataset.jyCountdown || '').trim();
    var durMatch = raw.match(/^(\d+)\s*h$/i);
    var rollMs = durMatch ? parseInt(durMatch[1], 10) * 3600000 : 0;
    /* a date with no time (2026-07-15) means end of that day, not NaN→evergreen */
    if (!rollMs && /^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      raw += 'T23:59:59';
    }
    if (!rollMs && raw && !/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) {
      raw = raw.replace(' ', 'T') + '+01:00';
    }
    var end = rollMs ? NaN : Date.parse(raw);
    var cd = { el: el, segs: segs, rollMs: rollMs, end: end, hasRealEnd: !isNaN(end), t: 0, done: false };
    cd.t = cdTarget(cd);
    CD_LIST.push(cd);
    cdRender(cd); /* immediate paint */
    if (!CD_TIMER) CD_TIMER = setInterval(cdTickAll, 1000);
  }

  /* ---------- recently viewed ---------- */
  var RECENT_KEY = 'jy_recent';

  function readRecent() {
    try {
      var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function writeRecent(items) {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 12)));
    } catch (e) {
      /* noop */
    }
  }

  /* On PDP: store the visited product (works wherever this file is loaded on /products/*) */
  function trackProductVisit() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9-_.]+)/i);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    fetch(window.location.pathname.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (!p || !p.handle) return;
        var items = readRecent().filter(function (it) {
          var h = typeof it === 'string' ? it : it && it.handle;
          return h !== p.handle;
        });
        items.unshift({
          handle: p.handle,
          title: p.title,
          url: '/products/' + p.handle,
          image: (p.featured_image || (p.images && p.images[0]) || '').toString(),
          price: p.price,
          compare: p.compare_at_price || 0,
          vendor: p.vendor || '',
        });
        writeRecent(items);
      })
      .catch(function () {
        /* noop */
      });
    void handle;
  }

  function formatMoney(cents) {
    // whole dirhams to match the store's money filter (no odd centimes)
    return String(Math.round((cents || 0) / 100));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function starsHtml(rating) {
    var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
    return (
      '<span class="jy-stars" style="--jy-rate: ' + pct + '%;" aria-hidden="true">' +
      '<span class="jy-stars__fill">★★★★★</span>★★★★★</span>'
    );
  }

  /* Vendor verified-seal color — same mapping as the Liquid snippet */
  var VENDOR_COLORS = {
    'justyol': '#c4301c',
    'caf chic': '#7c2d8a',
    'butik kolik': '#1d349a',
    'opiyane': '#0d8756',
    'jwomen': '#b5811f',
    'mu group': '#2b6f72',
  };
  var VENDOR_PALETTE = ['#c4301c', '#1d349a', '#7c2d8a', '#0d8756', '#b5811f', '#2b6f72'];
  function vendorColor(vendor) {
    var v = String(vendor || '');
    return VENDOR_COLORS[v.toLowerCase()] || VENDOR_PALETTE[v.length % 6];
  }

  function sealSvg(color) {
    return (
      '<svg width="11" height="11" viewBox="0 0 24 24" fill="' + color + '" aria-hidden="true">' +
      '<path d="M12 1l2.6 2.2 3.4-.2 1 3.2 3 1.7-1 3.1 1 3.1-3 1.7-1 3.2-3.4-.2L12 21l-2.6-2.2-3.4.2-1-3.2-3-1.7 1-3.1-1-3.1 3-1.7 1-3.2 3.4.2L12 1z"/>' +
      '<path d="M9.2 12.4l2 2 3.8-4.2" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  var BAG_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var HEART_SVG =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  /* Fetch /products/<handle>.js (slim payload cached in sessionStorage) */
  function fetchProductJson(handle) {
    var key = 'jy_pjson_' + handle;
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {
      /* noop */
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (!p || !p.handle) return null;
        var slim = {
          id: p.id,
          handle: p.handle,
          title: p.title,
          vendor: p.vendor || '',
          price: p.price,
          compare: p.compare_at_price || 0,
          url: '/products/' + p.handle,
          image: (p.featured_image || (p.images && p.images[0]) || '').toString(),
        };
        try {
          sessionStorage.setItem(key, JSON.stringify(slim));
        } catch (e) {
          /* noop */
        }
        return slim;
      })
      .catch(function () {
        return null;
      });
  }

  /* Full-detail card — visually identical to snippets/jy-product-card.liquid */
  function rvCardHtml(p, cur) {
    var onSale = p.compare && p.compare > p.price;
    var off = onSale ? Math.round(((p.compare - p.price) / p.compare) * 100) : 0;
    /* real reviews only — show the rating row only when the PDP stored a real
       score (no fabricated counts) */
    var hasRating = typeof p.rating === 'number' && p.rating > 0;
    var vcol = vendorColor(p.vendor);
    var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=360' : '';
    var url = escapeHtml(p.url);
    var title = escapeHtml(p.title);
    return (
      '<article class="jy-pcard jy-pcard--compact">' +
      '<div class="jy-pcard__media jy-imgwrap">' +
      '<a href="' + url + '" class="jy-pcard__media-link" aria-label="' + title + '" tabindex="-1">' +
      (off > 0 ? '<span class="jy-badge jy-badge--sale">−' + off + '%</span>' : '') +
      (img ? '<img class="jy-pcard__img" src="' + escapeHtml(img) + '" alt="' + title + '" width="360" height="360" loading="lazy">' : '') +
      '</a>' +
      '<a class="jy-pcard__fav" href="/pages/wishlist" aria-label="Wishlist">' + HEART_SVG + '</a>' +
      '</div>' +
      '<div class="jy-pcard__body">' +
      (p.vendor ? '<span class="jy-pcard__vendor">' + escapeHtml(p.vendor) + ' ' + sealSvg(vcol) + '</span>' : '') +
      '<h3 class="jy-pcard__title"><a href="' + url + '">' + title + '</a></h3>' +
      (hasRating
        ? '<div class="jy-pcard__rating">' +
          starsHtml(p.rating) +
          ' <b>' + p.rating.toFixed(1) + '</b>' +
          (p.ratingCount ? ' <span>(' + p.ratingCount + ')</span>' : '') +
          '</div>'
        : '') +
      '<div class="jy-pcard__foot">' +
      '<div class="jy-pcard__price">' +
      '<span class="jy-pcard__now">' + formatMoney(p.price || 0) + '<span class="jy-cur">' + escapeHtml(cur) + '</span></span>' +
      (onSale ? '<span class="jy-pcard__was">' + formatMoney(p.compare) + '</span>' : '') +
      '</div>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function initRecent(section) {
    if (section.dataset.jyInit) return;
    section.dataset.jyInit = '1';
    var rail = section.querySelector('[data-jy-recent-rail]');
    if (!rail) {
      section.style.display = 'none';
      return;
    }
    // jy_recent is backward compatible: entries are either "handle" strings
    // or {handle,...} objects — only the handle is used at render time.
    var pathNow = window.location.pathname;
    var handles = [];
    readRecent().forEach(function (it) {
      var h = typeof it === 'string' ? it : it && it.handle;
      if (h && handles.indexOf(h) === -1 && pathNow.indexOf('/products/' + h) === -1) handles.push(h);
    });
    handles = handles.slice(0, 10);
    if (handles.length === 0) {
      section.style.display = 'none';
      return;
    }
    var cur = section.dataset.jyCurrency || 'Dhs';
    Promise.all(handles.map(fetchProductJson)).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) {
        section.style.display = 'none';
        return;
      }
      rail.innerHTML = products
        .map(function (p) {
          return '<div class="jy-rv-cell">' + rvCardHtml(p, cur) + '</div>';
        })
        .join('');
      section.style.display = '';
    });
  }

  /* ---------- product-grid tabs (Pour vous) ---------- */
  function initGridTabs(tablist) {
    if (tablist.dataset.jyTabsInit) return;
    tablist.dataset.jyTabsInit = '1';
    var section = tablist.closest('.shopify-section') || tablist.parentElement;
    tablist.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-jy-tab]');
      if (!tab) return;
      var idx = tab.getAttribute('data-jy-tab');
      tablist.querySelectorAll('[data-jy-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('jy-chip--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      section.querySelectorAll('[data-jy-tab-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-jy-tab-panel') !== idx;
      });
    });
  }

  /* ---------- desktop rail arrows ----------
     brands / flash / recently-viewed rails hide their scrollbars; without
     arrows a desktop mouse user simply cannot reach the overflow cards. */
  function initRailArrows() {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    ['.jy-brandrail', '.jy-flash__rail', '.jy-rv-rail'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (rail) {
        if (rail.dataset.jyArrows) return;
        if (!rail.parentNode) return;
        rail.dataset.jyArrows = '1';
        /* wrap ONLY the rail so the arrows centre on the cards, not on the whole
           section (which includes the heading/countdown above the rail) */
        var wrap = document.createElement('div');
        wrap.className = 'jy-railwrap';
        rail.parentNode.insertBefore(wrap, rail);
        wrap.appendChild(rail);
        ['prev', 'next'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'jy-rail-arrow jy-rail-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'prev' ? 'Précédent' : 'Suivant');
          b.innerHTML =
            dir === 'prev'
              ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'
              : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
          b.addEventListener('click', function () {
            var rtl = document.documentElement.dir === 'rtl';
            var step = Math.round(rail.clientWidth * 0.8) * (dir === 'next' ? 1 : -1) * (rtl ? -1 : 1);
            rail.scrollBy({ left: step, behavior: 'smooth' });
          });
          wrap.appendChild(b);
        });
        function refresh() {
          wrap.classList.toggle('has-overflow', rail.scrollWidth > rail.clientWidth + 4);
        }
        refresh();
        window.addEventListener('resize', refresh);
      });
    });
  }

  /* ---------- flash sticky countdown: reveal once the hero scrolls away ---------- */
  function initFlashSticky() {
    var bar = document.querySelector('[data-jy-flash-sticky]');
    var hero = document.querySelector('.jy-flashero');
    /* separate guard from jyInit — the bar also carries data-jy-countdown, which
       uses jyInit, so sharing it would skip one of the two inits */
    if (!bar || !hero || bar.dataset.jyStickyInit || !('IntersectionObserver' in window)) return;
    bar.dataset.jyStickyInit = '1';
    bar.hidden = false; /* CSS keeps it off-screen until .is-on */
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting);
        });
      },
      { threshold: 0 }
    ).observe(hero);
  }

  function initAll() {
    document.querySelectorAll('[data-jy-hslider]').forEach(initSlider);
    document.querySelectorAll('[data-jy-hcar]').forEach(initCarousel);
    document.querySelectorAll('[data-jy-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-jy-recent]').forEach(initRecent);
    document.querySelectorAll('.jy-grid-tabs').forEach(initGridTabs);
    initFlashSticky();
    trackProductVisit();
    initRailArrows();
    /* recently-viewed renders async — sweep again once it's likely in */
    setTimeout(initRailArrows, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
